/**
 * Calculates the distance between two points on the Earth's surface using the Haversine formula.
 * @param {number} lat1 
 * @param {number} lon1 
 * @param {number} lat2 
 * @param {number} lon2 
 * @returns {number} Distance in kilometers
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * (Math.PI / 180);
  const dLon = (lon2 - lon1) * (Math.PI / 180);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * (Math.PI / 180)) *
      Math.cos(lat2 * (Math.PI / 180)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

/**
 * Estimates MET (Metabolic Equivalent of Task) based on running speed.
 * @param {number} speedKph Speed in km/h
 * @returns {number} MET value
 */
export const getMETForSpeed = (speedKph) => {
  if (speedKph <= 0) return 1.0; // Rest/Stationary
  if (speedKph < 6.4) return 3.5; // Walking
  if (speedKph < 8.0) return 8.3; // Very slow run
  if (speedKph < 9.6) return 9.8; // Slow run
  if (speedKph < 11.3) return 11.0; // Moderate run
  if (speedKph < 12.8) return 12.8; // Fast run
  return 14.5; // Very fast run
};

/**
 * Calculates estimated calories burned.
 * @param {number} met MET value
 * @param {number} weightKg User weight in kg
 * @param {number} durationHours Duration in hours
 * @returns {number} Estimated calories
 */
export const calculateCalories = (met, weightKg, durationHours) => {
  return met * weightKg * durationHours;
};
